import { matchPath } from 'react-router'

/**
 * The app's route templates, as analytics reports them. `routes.tsx` is the source of truth and
 * `routeTemplates.test.ts` fails when a path there is missing here. A parameter such as `:id` stands for
 * a value that must never reach the counter (a transcription id), so only the template is reported.
 */
export const ROUTE_TEMPLATES = [
  '/',
  '/admin',
  '/login',
  '/signup',
  '/verify',
  '/forgot',
  '/reset',
  '/transcriptions/:id',
  '/keys',
  '/billing',
  '/billing/success',
  '/billing/cancel',
] as const

/** Reported for an address that matches no route (the not-found page), so a mistyped or odd path is never recorded. */
export const UNKNOWN_ROUTE = '/*'

/** The template for a path, or `/*` when no route matches. Only the path is read; query and hash are ignored. */
export function routeTemplate(pathname: string): string {
  for (const template of ROUTE_TEMPLATES) {
    if (matchPath({ path: template, end: true }, pathname)) return template
  }
  return UNKNOWN_ROUTE
}
